"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function getHighlight(label, appearance, highlight) {
  if (label) {
    var _highlight$level;
    return {
      appearance: appearance,
      level: (_highlight$level = highlight === null || highlight === void 0 ? void 0 : highlight.level) !== null && _highlight$level !== void 0 ? _highlight$level : 1
    };
  }
  if (highlight !== null && highlight !== void 0 && highlight.appearance) {
    var _highlight$level2;
    return {
      appearance: highlight.appearance,
      level: (_highlight$level2 = highlight.level) !== null && _highlight$level2 !== void 0 ? _highlight$level2 : 1
    };
  }
}
var _default = getHighlight;
exports["default"] = _default;
//# sourceMappingURL=getHighlight.js.map